import {
  Component,
  OnDestroy,
  ViewChild,
  OnInit,
  ViewContainerRef,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Member, TeamTexts } from "@/core/models";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-membernames-list",
  templateUrl: "membernameslist.component.html",
})
export class MemberNamesListComponent implements OnDestroy, OnInit {
  @ViewChild("template", { static: true }) template;
  @Input() members: Member[];
  @Input() texts: TeamTexts;
  subs = new SubSink();
  cssColor: string;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private configurationService: ConfigurationService
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      }
    );
  }

  sortBy(prop: string) {
    return this.members.sort((a, b) =>
      a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1
    );
  }

  ngOnInit() {
    this.viewContainerRef.createEmbeddedView(this.template);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
